export const formatNumber = (value: number): string =>
  value.toLocaleString('pt-BR');

// Médias vêm null quando não há visitas.
export const formatDecimal = (value: number | null): string =>
  value === null || value === undefined
    ? '-'
    : value.toLocaleString('pt-BR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

export const formatPercent = (value: number): string =>
  `${formatDecimal(value)}%`;
